/** Stable palette so the same trajectoryId keeps the same color across 2D/3D charts. */
const TRAJECTORY_LINE_COLORS = [
  '#4C9AFF',
  '#FF8B00',
  '#36B37E',
  '#6554C0',
  '#FF5630',
  '#00B8D9',
  '#FFC400',
  '#8777D9',
  '#57D9A3',
  '#FF7452',
] as const;

/** Offset so dual-x series (Incl vs Azi) of the same trajectory stay distinct. */
const DUAL_SERIES_PALETTE_OFFSET = 5;

export const MAIN_TRAJECTORY_LINE_WIDTH = 3;
export const REFERENCE_TRAJECTORY_LINE_WIDTH = 2;

export function getTrajectoryLineColor(trajectoryId: number): string {
  const index = Math.abs(trajectoryId) % TRAJECTORY_LINE_COLORS.length;

  return TRAJECTORY_LINE_COLORS[index] ?? TRAJECTORY_LINE_COLORS[0];
}

/**
 * Color for a chart series of a trajectory.
 * `seriesIndex === 0` — base trajectory color; higher indices shift along the palette (dual-x Incl/Azi).
 */
export function getTrajectorySeriesColor(trajectoryId: number, seriesIndex = 0): string {
  if (seriesIndex <= 0) {
    return getTrajectoryLineColor(trajectoryId);
  }

  const index = (Math.abs(trajectoryId) + seriesIndex * DUAL_SERIES_PALETTE_OFFSET) % TRAJECTORY_LINE_COLORS.length;

  return TRAJECTORY_LINE_COLORS[index] ?? TRAJECTORY_LINE_COLORS[0];
}
